import { authRoles } from "../../auth/authRoles";
import EditKota from "./EditKota";
import Kota from "./Kota";
import TambahKota from "./TambahKota";

const kotaRoutes = [
  {
    path: "/kota/edit/:id",
    exact: true,
    component: EditKota,
    auth: authRoles.all,
  },
  {
    path: "/kota/tambah",
    exact: true,
    component: TambahKota,
    auth: authRoles.all,
  },
  {
    path: "/kota",
    exact: true,
    component: Kota,
    auth: authRoles.all,
  },
];

export default kotaRoutes;
